import AttachmentOpenAction from '../schema/AttachmentOpenAction';
import AttachmentPreviewMethod from '../schema/AttachmentPreviewMethod';
import AttachmentViewStrategy from '../schema/AttachmentViewStrategy';

export default function disableAttachmentPreview(strategy: AttachmentViewStrategy): void {
    strategy.previewMethod = AttachmentPreviewMethod.Unsupported;
    strategy.supportedOpenActions = strategy.supportedOpenActions.filter(
        action => action !== AttachmentOpenAction.Preview
    );
}
